/**
 * Map of ISO 639-3 codes to terminologic ISO 639-2 codes.
 *
 * @type {Record<string, string>}
 */
export const iso6393To2T = {
  aar: 'aar',
  abk: 'abk',
  ace: 'ace',
  ach: 'ach',
  ada: 'ada',
  ady: 'ady',
  afh: 'afh',
  afr: 'afr',
  ain: 'ain',
  aka: 'aka',
  akk: 'akk',
  ale: 'ale',
  alt: 'alt',
  amh: 'amh',
  ang: 'ang',
  anp: 'anp',
  ara: 'ara',
  arc: 'arc',
  arg: 'arg',
  arn: 'arn',
  arp: 'arp',
  arw: 'arw',
  asm: 'asm',
  ast: 'ast',
  ava: 'ava',
  ave: 'ave',
  awa: 'awa',
  aym: 'aym',
  aze: 'aze',
  bak: 'bak',
  bal: 'bal',
  bam: 'bam',
  ban: 'ban',
  bas: 'bas',
  bej: 'bej',
  bel: 'bel',
  bem: 'bem',
  ben: 'ben',
  bho: 'bho',
  bik: 'bik',
  bin: 'bin',
  bis: 'bis',
  bla: 'bla',
  bod: 'bod',
  bos: 'bos',
  bra: 'bra',
  bre: 'bre',
  bua: 'bua',
  bug: 'bug',
  bul: 'bul',
  byn: 'byn',
  cad: 'cad',
  car: 'car',
  cat: 'cat',
  ceb: 'ceb',
  ces: 'ces',
  cha: 'cha',
  chb: 'chb',
  che: 'che',
  chg: 'chg',
  chk: 'chk',
  chm: 'chm',
  chn: 'chn',
  cho: 'cho',
  chp: 'chp',
  chr: 'chr',
  chu: 'chu',
  chv: 'chv',
  chy: 'chy',
  cnr: 'cnr',
  cop: 'cop',
  cor: 'cor',
  cos: 'cos',
  cre: 'cre',
  crh: 'crh',
  csb: 'csb',
  cym: 'cym',
  dak: 'dak',
  dan: 'dan',
  dar: 'dar',
  del: 'del',
  den: 'den',
  deu: 'deu',
  dgr: 'dgr',
  din: 'din',
  div: 'div',
  doi: 'doi',
  dsb: 'dsb',
  dua: 'dua',
  dum: 'dum',
  dyu: 'dyu',
  dzo: 'dzo',
  efi: 'efi',
  egy: 'egy',
  eka: 'eka',
  ell: 'ell',
  elx: 'elx',
  eng: 'eng',
  enm: 'enm',
  epo: 'epo',
  est: 'est',
  eus: 'eus',
  ewe: 'ewe',
  ewo: 'ewo',
  fan: 'fan',
  fao: 'fao',
  fas: 'fas',
  fat: 'fat',
  fij: 'fij',
  fil: 'fil',
  fin: 'fin',
  fon: 'fon',
  fra: 'fra',
  frm: 'frm',
  fro: 'fro',
  frr: 'frr',
  frs: 'frs',
  fry: 'fry',
  ful: 'ful',
  fur: 'fur',
  gaa: 'gaa',
  gay: 'gay',
  gba: 'gba',
  gez: 'gez',
  gil: 'gil',
  gla: 'gla',
  gle: 'gle',
  glg: 'glg',
  glv: 'glv',
  gmh: 'gmh',
  goh: 'goh',
  gon: 'gon',
  gor: 'gor',
  got: 'got',
  grb: 'grb',
  grc: 'grc',
  grn: 'grn',
  gsw: 'gsw',
  guj: 'guj',
  gwi: 'gwi',
  hai: 'hai',
  hat: 'hat',
  hau: 'hau',
  haw: 'haw',
  heb: 'heb',
  her: 'her',
  hil: 'hil',
  hin: 'hin',
  hit: 'hit',
  hmn: 'hmn',
  hmo: 'hmo',
  hrv: 'hrv',
  hsb: 'hsb',
  hun: 'hun',
  hup: 'hup',
  hye: 'hye',
  iba: 'iba',
  ibo: 'ibo',
  ido: 'ido',
  iii: 'iii',
  iku: 'iku',
  ile: 'ile',
  ilo: 'ilo',
  ina: 'ina',
  ind: 'ind',
  inh: 'inh',
  ipk: 'ipk',
  isl: 'isl',
  ita: 'ita',
  jav: 'jav',
  jbo: 'jbo',
  jpn: 'jpn',
  jpr: 'jpr',
  jrb: 'jrb',
  kaa: 'kaa',
  kab: 'kab',
  kac: 'kac',
  kal: 'kal',
  kam: 'kam',
  kan: 'kan',
  kas: 'kas',
  kat: 'kat',
  kau: 'kau',
  kaw: 'kaw',
  kaz: 'kaz',
  kbd: 'kbd',
  kha: 'kha',
  khm: 'khm',
  kho: 'kho',
  kik: 'kik',
  kin: 'kin',
  kir: 'kir',
  kmb: 'kmb',
  kok: 'kok',
  kom: 'kom',
  kon: 'kon',
  kor: 'kor',
  kos: 'kos',
  kpe: 'kpe',
  krc: 'krc',
  krl: 'krl',
  kru: 'kru',
  kua: 'kua',
  kum: 'kum',
  kur: 'kur',
  kut: 'kut',
  lad: 'lad',
  lah: 'lah',
  lam: 'lam',
  lao: 'lao',
  lat: 'lat',
  lav: 'lav',
  lez: 'lez',
  lim: 'lim',
  lin: 'lin',
  lit: 'lit',
  lol: 'lol',
  loz: 'loz',
  ltz: 'ltz',
  lua: 'lua',
  lub: 'lub',
  lug: 'lug',
  lui: 'lui',
  lun: 'lun',
  luo: 'luo',
  lus: 'lus',
  mad: 'mad',
  mag: 'mag',
  mah: 'mah',
  mai: 'mai',
  mak: 'mak',
  mal: 'mal',
  man: 'man',
  mar: 'mar',
  mas: 'mas',
  mdf: 'mdf',
  mdr: 'mdr',
  men: 'men',
  mga: 'mga',
  mic: 'mic',
  min: 'min',
  mis: 'mis',
  mkd: 'mkd',
  mlg: 'mlg',
  mlt: 'mlt',
  mnc: 'mnc',
  mni: 'mni',
  moh: 'moh',
  mon: 'mon',
  mos: 'mos',
  mri: 'mri',
  msa: 'msa',
  mul: 'mul',
  mus: 'mus',
  mwl: 'mwl',
  mwr: 'mwr',
  mya: 'mya',
  myv: 'myv',
  nap: 'nap',
  nau: 'nau',
  nav: 'nav',
  nbl: 'nbl',
  nde: 'nde',
  ndo: 'ndo',
  nds: 'nds',
  nep: 'nep',
  new: 'new',
  nia: 'nia',
  niu: 'niu',
  nld: 'nld',
  nno: 'nno',
  nob: 'nob',
  nog: 'nog',
  non: 'non',
  nor: 'nor',
  nqo: 'nqo',
  nso: 'nso',
  nwc: 'nwc',
  nya: 'nya',
  nym: 'nym',
  nyn: 'nyn',
  nyo: 'nyo',
  nzi: 'nzi',
  oci: 'oci',
  oji: 'oji',
  ori: 'ori',
  orm: 'orm',
  osa: 'osa',
  oss: 'oss',
  ota: 'ota',
  pag: 'pag',
  pal: 'pal',
  pam: 'pam',
  pan: 'pan',
  pap: 'pap',
  pau: 'pau',
  peo: 'peo',
  phn: 'phn',
  pli: 'pli',
  pol: 'pol',
  pon: 'pon',
  por: 'por',
  pro: 'pro',
  pus: 'pus',
  que: 'que',
  raj: 'raj',
  rap: 'rap',
  rar: 'rar',
  roh: 'roh',
  rom: 'rom',
  ron: 'ron',
  run: 'run',
  rup: 'rup',
  rus: 'rus',
  sad: 'sad',
  sag: 'sag',
  sah: 'sah',
  sam: 'sam',
  san: 'san',
  sas: 'sas',
  sat: 'sat',
  scn: 'scn',
  sco: 'sco',
  sel: 'sel',
  sga: 'sga',
  shn: 'shn',
  sid: 'sid',
  sin: 'sin',
  slk: 'slk',
  slv: 'slv',
  sma: 'sma',
  sme: 'sme',
  smj: 'smj',
  smn: 'smn',
  smo: 'smo',
  sms: 'sms',
  sna: 'sna',
  snd: 'snd',
  snk: 'snk',
  sog: 'sog',
  som: 'som',
  sot: 'sot',
  spa: 'spa',
  sqi: 'sqi',
  srd: 'srd',
  srn: 'srn',
  srp: 'srp',
  srr: 'srr',
  ssw: 'ssw',
  suk: 'suk',
  sun: 'sun',
  sus: 'sus',
  sux: 'sux',
  swa: 'swa',
  swe: 'swe',
  syc: 'syc',
  syr: 'syr',
  tah: 'tah',
  tam: 'tam',
  tat: 'tat',
  tel: 'tel',
  tem: 'tem',
  ter: 'ter',
  tet: 'tet',
  tgk: 'tgk',
  tgl: 'tgl',
  tha: 'tha',
  tig: 'tig',
  tir: 'tir',
  tiv: 'tiv',
  tkl: 'tkl',
  tlh: 'tlh',
  tli: 'tli',
  tmh: 'tmh',
  tog: 'tog',
  ton: 'ton',
  tpi: 'tpi',
  tsi: 'tsi',
  tsn: 'tsn',
  tso: 'tso',
  tuk: 'tuk',
  tum: 'tum',
  tur: 'tur',
  tvl: 'tvl',
  twi: 'twi',
  tyv: 'tyv',
  udm: 'udm',
  uga: 'uga',
  uig: 'uig',
  ukr: 'ukr',
  umb: 'umb',
  und: 'und',
  urd: 'urd',
  uzb: 'uzb',
  vai: 'vai',
  ven: 'ven',
  vie: 'vie',
  vol: 'vol',
  vot: 'vot',
  wal: 'wal',
  war: 'war',
  was: 'was',
  wln: 'wln',
  wol: 'wol',
  xal: 'xal',
  xho: 'xho',
  yao: 'yao',
  yap: 'yap',
  yid: 'yid',
  yor: 'yor',
  zap: 'zap',
  zbl: 'zbl',
  zen: 'zen',
  zgh: 'zgh',
  zha: 'zha',
  zho: 'zho',
  zul: 'zul',
  zun: 'zun',
  zxx: 'zxx',
  zza: 'zza'
}
